const routes = [
    {
        path: "/reports/student",
        component: () => import("../pages/student/Index"),
        meta: {
            isAuthenticated: true,
            permission: "studentreport_index"
        }
    }
];

export default routes;
